import { useEffect, useMemo, useState } from "react";

import { currentUserId, currentUserToken, isAdmin } from "../../utils/constants";
import { localStorageInstance } from "../../utils/localStorage";
import { subscriptionManager } from "../../utils/subscriptionManager";
import { getAuthState, getRedirectLocation } from "../utils/routeUtils";

export function usePrivateRoute(location) {
  const [subscriptionExpired, setSubscriptionExpired] = useState(
    subscriptionManager.getStatus()
  );
  const redirectLocation = useMemo(
    () => getRedirectLocation(location),
    [location]
  );

  useEffect(() => {
    localStorageInstance.setItem({
      key: "redirectLocation",
      value: redirectLocation,
    });
  }, [redirectLocation]);

  useEffect(() => {
    return subscriptionManager.subscribe((isExpired) => {
      setSubscriptionExpired(Boolean(isExpired));
    });
  }, []);

  const auth = getAuthState({
    token: currentUserToken(),
    userId: currentUserId(),
  });
  const hasSuperAdminRole = isAdmin();
  const isAdminUserPage = location?.pathname === "/admin-user";

  return {
    isAuthenticated: auth,
    shouldRedirectToAdminUsers:
      auth && subscriptionExpired && hasSuperAdminRole && !isAdminUserPage,
    shouldBlockForExpiredPlan:
      auth && subscriptionExpired && !hasSuperAdminRole,
  };
}
